<template>
  <div class="flex">
    <div class="w-256 mr-16">
      <h3 class="text-overline mb-4">Type</h3>
      <p class="text-body text-left mb-16">Occasional sitter</p>
      <h3 class="text-overline mb-4">Start Date</h3>
      <p :class="`text-body text-left ${startDateFlexible ? '' : 'mb-16'}`">{{ formattedStartDate }}</p>
      <p v-if="startDateFlexible" id="start-date-flexible" class="text-body text-left mb-16 italic">Start date is flexible</p>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'JobPostScheduleOccasionalReview',
  props: {
    formattedStartDate: {
      type: String,
      required: true,
    },
    startDateFlexible: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
